import React, { Component } from 'react';
import {  withRouter } from 'react-router-dom'

import "bootstrap/dist/css/bootstrap.min.css";
import '../css/navBar_custom.css'

import { HOST } from '../auxiliar/constants'

import { withTranslation } from 'react-i18next';
import { options } from '../../config/options';

import logo from '../../images/logo_2.png';

class MainNav extends Component {

    state = {
        lang: options[0],
        isToggleOn: false,
        // bg_class: "sliderhome_nav navbar navbar-expand-lg navbar-dark"
        bg_class: " navbar navbar-expand-xl navbar-dark"
    };

    componentDidMount() {
        //console.log("NAVBAR DIDMOUNT")
        // if(this.props.location.pathname == "/"){
        //     this.setState({bg_class: "sliderhome_nav navbar navbar-expand-lg navbar-dark"})
        // }else{
        //     this.setState({bg_class: "mainContainer_nav navbar navbar-expand-lg navbar-dark"})
        // }
        switch (this.props.i18n.language) {
            case "en":
                this.setState({ lang: options[0] })
                break;
            case "es":
                this.setState({ lang: options[0] })
                break;
            case "pt":
                this.setState({ lang: options[0] })
                break;
            default:
                break;
        }
    }

    changeLang = (lang) => {
        const { i18n } = this.props;
        const { value } = lang;

        this.setState({ lang });
        i18n.changeLanguage(value);
        // console.log("changeLang - ", this.props)
    };

    changeLang_li = (lang) => {
        const { i18n } = this.props;
        var value = {}

        switch (lang.target.id) {
            case "en":
                value = options[1]
                break;
            case "es":
                value = options[0]
                break;
            case "pt":
                value = options[2]
                break;
            default:
                break;
        }

        this.setState({ lang: value });
        i18n.changeLanguage(lang.target.id);
        // console.log("changeLang_li - ", this.props)
    };

    getNavLinkClass = (path) => {
        //console.log(path)
        return this.props.location.pathname === path ? 'active nav-item' : 'nav-item';
    }

    showMenu(e) {
        e.preventDefault();
        this.setState(prevState => ({
            isToggleOn: !prevState.isToggleOn
        }));
    }

    render() {
        const { t } = this.props;

        const collapse_menu = "collapse navbar-collapse" + (this.state.isToggleOn ? " show" : "");

        //console.log("process.env.PUBLIC_URL - ", `${process.env.PUBLIC_URL}`)

        var lang_links = options.map((op, i) => {
            if (this.state.lang.value === op.value) {
                return <li key={i} id={op.value} className="ml-2 mr-1 link_languaje" onClick={this.changeLang_li} style={{ borderBottom: "2px solid #fff" }}>
                    {op.value.toUpperCase()}
                </li >
            } else {
                return <li key={i} id={op.value} className="ml-2 mr-1 link_languaje" onClick={this.changeLang_li}>
                    {op.value.toUpperCase()}
                </li >
            }

        })

        return (
            <nav className={this.state.bg_class} >
                <a className="navbar-brand" href={HOST}>
                    <img src={logo} width="auto" height="45" className="d-inline-block" alt="" />
                    <h1>LIFE17 GIE/ES/000515</h1>
                </a>
                <button onClick={e => { this.showMenu(e) }} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={collapse_menu} id="navbarNav">
                    <ul className="navbar-nav mr-auto">
                        {/* <li className={this.getNavLinkClass("/")}>
                            <NavLink className="nav-link" to="/" >{t("menu_home")}</NavLink>
                        </li> */}
                        {/* <li className={this.getNavLinkClass("/")} onClick={e => { this.showMenu(e) }}>
                            <NavLink className="nav-link" to="/">{t("home")}</NavLink>
                        </li>
                        <li className={this.getNavLinkClass("/about")} onClick={e => { this.showMenu(e) }}>
                            <NavLink className="nav-link" to="/about">{t("about")}</NavLink>
                        </li>
                        <li className={this.getNavLinkClass("/resources")} onClick={e => { this.showMenu(e) }}>
                            <NavLink className="nav-link" to="/resources">{t("resources")}</NavLink>
                        </li>
                        <li className={this.getNavLinkClass("/training")} onClick={e => { this.showMenu(e) }}>
                            <NavLink className="nav-link" to="/training">{t("training")}</NavLink>
                        </li>
                        <li className={this.getNavLinkClass("/take-part")} onClick={e => { this.showMenu(e) }}>
                            <NavLink className="nav-link" to="/take-part">{t("take part")}</NavLink>
                        </li>
                        <li className={this.getNavLinkClass("/visor")} onClick={e => { this.showMenu(e) }}>
                            <NavLink className="nav-link" to="/visor">{t("visor")}</NavLink>
                        </li>
                        <li className={this.getNavLinkClass("/EEI_finder")} onClick={e => { this.showMenu(e) }}>
                            <NavLink className="nav-link" to="/EEI_finder">{t("EEI cards")}</NavLink>
                        </li>  */}
                        <li className="nav-item">
                            <a className="nav-link" href="/">{t("home")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/acerca-de">{t("about")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/recursos">{t("resources")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/training">{t("training")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/take-part">{t("take part")}</a>
                        </li>
                        <li className="active nav-item">
                            <a className="nav-link" href="/visor">{t("visor")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/eei_cards">{t("EEI cards")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://eei.sibic.org" target="_blank" rel="noopener noreferrer">{t("SIBIC-EEI")}</a>
                        </li>
                    </ul>
                    <span className="navbar-text col-xl-2 col-lg-2 col-xs-12 languages mr-2">
                        <ul className="navbar-nav mr-auto" onClick={e => { this.showMenu(e) }}>
                            {lang_links}
                        </ul>
                    </span>
                </div>
            </nav >
        )
    }
};

MainNav = withRouter(MainNav);
export default withTranslation()(MainNav);
